export default __webpack_public_path__ + "static/media/DarkleftSideHeader.23aab53e.png";